<div class="wk-insert-link">
  <header mat-dialog-header>
    <h3 class="mb-0" mat-dialog-title>
      {{ 'ADF_INSERT_LINK.TITLE' | translate }}
    </h3>

    <button mat-icon-button class="close-icon" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <section class="section">
    <mat-tab-group
      [(selectedIndex)]="selectedIndex"
      class="adf-info-drawer-tabs"
      (selectedTabChange)="onTabChange($event)"
    >
      <mat-tab
        *ngFor="let contentBlock of contentBlocks"
        [label]="contentBlock.label | translate"
        class="adf-info-drawer-tab"
        [disabled]="!checkIfTabEnabled(contentBlock.linkedCommand)"
      >
        <ng-template mat-tab-label>
          <span *ngIf="contentBlock.label">{{
            contentBlock.label | translate
          }}</span>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
    <ng-template #container> </ng-template>
  </section>
</div>
